import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Anchor, Group, Paper, Text } from "@mantine/core";
import { ActivityTimeline, bookingChainKey, groupEvents } from "@nodus/ui";
import { toTimelineEventView, type MemberEvent } from "@/lib/activity";

const MAX_ROWS = 5;

export interface RecentActivityCardProps {
  events: MemberEvent[] | undefined;
  isLoading: boolean;
  error: boolean;
}

/** Dashboard card: the member's newest activity as a compact timeline
 *  (bursts collapse into one "+N more" row), linking to the Activity page. */
export function RecentActivityCard({ events, isLoading, error }: RecentActivityCardProps) {
  const items = useMemo(
    () => groupEvents((events ?? []).map(toTimelineEventView), { getChainKey: bookingChainKey }).slice(0, MAX_ROWS),
    [events],
  );
  return (
    <Paper withBorder p="lg" radius="md">
      <Group justify="space-between" mb="md">
        <Text fw={600}>Recent activity</Text>
        <Anchor component={Link} to="/activity" fz="sm">
          View all
        </Anchor>
      </Group>
      {isLoading ? (
        <Text fz="sm" c="dimmed">Loading activity…</Text>
      ) : error ? (
        <Text fz="sm" c="red">Activity could not be loaded.</Text>
      ) : items.length === 0 ? (
        <Text fz="sm" c="dimmed">No recent activity on the floors you have access to.</Text>
      ) : (
        <ActivityTimeline items={items} />
      )}
    </Paper>
  );
}
